import { useTranslation } from 'react-i18next';

import { usePriceVisible } from 'hooks/usePriceVisible';

import { formatOrderPrice } from 'helpers/parsePrice';

import * as S from './OrderFooter.styles';

type OrderFooterProps = {
  quantity: number;
  price: number | string;
  currency: string;
};

export function OrderFooter(props: OrderFooterProps): React.ReactElement {
  const { quantity, price, currency } = props;
  const { t } = useTranslation();
  const priceVisible = usePriceVisible();

  return (
    <S.Footer data-testid="order-footer">
      <S.TotalGroup>
        <S.Label>{t('orderTable.totalQty')}</S.Label>
        <S.QuantityValue data-testid="order-footer-quantity">{quantity}</S.QuantityValue>
      </S.TotalGroup>
      {priceVisible && (
        <S.TotalGroup>
          <S.Label>{t('orderTable.footer.totalAmount')}</S.Label>
          <S.PriceValue data-testid="order-footer-price">
            {formatOrderPrice(currency, price)}
          </S.PriceValue>
        </S.TotalGroup>
      )}
    </S.Footer>
  );
}
